const API = 'StockDiamondToDiamondKeySymbols';

export const API_STOCK_DIAMOND_TO_DIAMOND_KEY_SYMBOLS = {
  POST_BULK: `${API}/CreateStockDiamondToDiamondKeySymbolBulk`,
};
